module.exports = __webpack_public_path__ + "static/media/55_000039.7ec59cf7.jpg";